import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "featured-category",
  label: "Featured Category",
  description: "A collection block: one tall captioned tile for a category beside a grid of its products and a View more tile.",
  supportedPages: ["home", "product", "cart"],
  variants: [
    { id: "v1", label: "Big tile left" },
    { id: "v2", label: "Big tile right" },
  ],
  commonFields: [
    { key: "categoryId", label: "Select Category", type: "category-select" },
    { key: "title", label: "Tile caption", type: "string", help: "Empty = the category name. With no category picked, the category with this exact name is shown." },
    { key: "subtitle", label: "Line above the caption", type: "string" },
    { key: "image", label: "Tile picture", type: "image", help: "Portrait. Empty = the category picture." },
    { key: "rows", label: "Rows of products (four each)", type: "number", default: 2 },
    { key: "viewAllText", label: "Last tile text", type: "string", default: "View more" },
    {
      key: "productCardVariant",
      label: "Product Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1",
    },
    { key: "noSelectionText", label: "No Category Selected Text", type: "string", default: "Please select a category in the editor settings." },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    ...SECTION_STYLE_FIELDS,
  ],
};
